function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import { makeComplexAttributePropType } from '../../utils/helpers';
import { generateClassNames, getPipedProps } from '../../enhancers/utils';
import { localPropsMap, breakpoint, SIZES, SIZES_ROUND, WIDTHS, HEIGHTS, THEMES } from './params';
import css from './Button.sass';
import { getTheme } from './helpers';
export var BaseButton =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(BaseButton, _PureComponent);

  function BaseButton() {
    _classCallCheck(this, BaseButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(BaseButton).apply(this, arguments));
  }

  _createClass(BaseButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          content = _this$props.content,
          disabled = _this$props.disabled,
          basic = _this$props.basic,
          primary = _this$props.primary,
          secondary = _this$props.secondary,
          pressed = _this$props.pressed,
          hovered = _this$props.hovered,
          inverted = _this$props.inverted,
          whiteBg = _this$props.whiteBg,
          rounded = _this$props.rounded,
          round = _this$props.round,
          opacity = _this$props.opacity,
          size = _this$props.size,
          width = _this$props.width,
          fluid = _this$props.fluid,
          fluidL = _this$props.fluidL,
          fluidM = _this$props.fluidM,
          fluidS = _this$props.fluidS,
          fluidXS = _this$props.fluidXS,
          noSpacing = _this$props.noSpacing,
          shadow = _this$props.shadow,
          loading = _this$props.loading,
          icon = _this$props.icon,
          href = _this$props.href,
          to = _this$props.to,
          onClick = _this$props.onClick,
          className = _this$props.className,
          blank = _this$props.blank,
          theme = _this$props.theme,
          as = _this$props.as,
          innerRef = _this$props.innerRef,
          ref = _this$props.ref,
          rest = _objectWithoutProperties(_this$props, ["children", "content", "disabled", "basic", "primary", "secondary", "pressed", "hovered", "inverted", "whiteBg", "rounded", "round", "opacity", "size", "width", "fluid", "fluidL", "fluidM", "fluidS", "fluidXS", "noSpacing", "shadow", "loading", "icon", "href", "to", "onClick", "className", "blank", "theme", "as", "innerRef", "ref"]);

      var themeKey = getTheme({
        primary: primary,
        secondary: secondary,
        whiteBg: whiteBg,
        opacity: opacity,
        theme: theme
      });
      var classNames = cx(css.root, basic && css.basic, opacity && css.opacity, disabled && css.disabled, inverted && css.inverted, rounded && css.rounded, round && css.round, fluid && css.fluid, fluidL && css['fluid-l'], fluidM && css['fluid-m'], fluidS && css['fluid-s'], fluidXS && css['fluid-xs'], noSpacing && css.noSpacing, pressed && css.pressed, hovered && css.hovered, shadow && css.shadow, loading && css.loading, size && css["size-".concat(size)], width && css["width-".concat(width)], theme && css["theme-".concat(themeKey)], generateClassNames(this.props, undefined, localPropsMap, '', css), className);
      var buttonProps = disabled ? {
        disabled: true
      } : {
        to: to,
        href: href,
        onClick: onClick,
        target: blank && '_blank'
      };
      var Element = as || (disabled ? 'button' : href ? 'a' : to ? Link : 'button');
      var pipedProps = getPipedProps(rest, undefined, localPropsMap);
      return React.createElement(Element, _extends({}, buttonProps, {
        className: classNames,
        ref: innerRef || ref
      }, pipedProps), icon && React.createElement("span", {
        className: css.icon
      }, icon), !!(content || children) && React.createElement("span", {
        className: css.text
      }, content || children));
    }
  }]);

  return BaseButton;
}(PureComponent);

_defineProperty(BaseButton, "displayName", 'Button');

_defineProperty(BaseButton, "propTypes", _objectSpread({
  /**
   * Node type
   */
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /**
   * Custom CSS class name
   */
  className: PropTypes.string,

  /**
   *  attr tagret='_blank'
   */
  blank: PropTypes.bool,

  /**
   *  Link href
   */
  href: PropTypes.string,

  /**
   * React router link to
   */
  to: PropTypes.string,

  /**
   * Primary content
   */
  children: PropTypes.node,

  /**
   * Primary content
   */
  content: PropTypes.node,

  /**
   *  Basic button
   */
  basic: PropTypes.bool,

  /**
   * Disabled
   */
  disabled: PropTypes.bool,

  /**
   * is pressed
   */
  pressed: PropTypes.bool,

  /**
   * is hovered
   */
  hovered: PropTypes.bool,

  /**
   *  Is primary
   */
  primary: PropTypes.bool,

  /**
   *  Is secondary
   */
  secondary: PropTypes.bool,

  /**
   *  Is inverted
   */
  inverted: PropTypes.bool,

  /**
   *  Is inverted
   */
  whiteBg: PropTypes.bool,

  /**
   *  Is opacity white
   */
  opacity: PropTypes.bool,

  /**
   *  Is rounded
   */
  rounded: PropTypes.bool,

  /**
   *  Is round (in a shape of circle)
   */
  round: PropTypes.bool,

  /**
   *  Sizes
   */
  size: PropTypes.oneOf([].concat(_toConsumableArray(Object.keys(SIZES)), _toConsumableArray(Object.keys(SIZES_ROUND)))),

  /**
   *  Widths
   */
  width: PropTypes.oneOf(Object.keys(WIDTHS))
}, makeComplexAttributePropType([Object.keys(localPropsMap), // eslint-disable-line array-element-newline
Object.keys(breakpoint)], Object.keys(HEIGHTS)), {
  /**
   * Indicates if there should not be any margin
   * between this button and the previous one
   */
  noSpacing: PropTypes.bool,

  /**
   *  Fluid width
   */
  fluid: PropTypes.bool,
  fluidL: PropTypes.bool,
  fluidM: PropTypes.bool,
  fluidS: PropTypes.bool,
  fluidXS: PropTypes.bool,

  /**
   *  Has shadow
   */
  shadow: PropTypes.bool,

  /**
   *  Is loading
   */
  loading: PropTypes.bool,

  /**
   * Button icon
   */
  icon: PropTypes.node,

  /** * On click callback */
  onClick: PropTypes.func,

  /** Function to make inner ref (from toolptips mostly) */
  innerRef: PropTypes.func,

  /** Function to make ref */
  ref: PropTypes.func,

  /** Themes */
  theme: PropTypes.oneOf(Object.keys(THEMES))
}));

_defineProperty(BaseButton, "defaultProps", {
  size: 'm',
  rounded: true,
  basic: false,
  theme: 'default'
});